import {
  aChainRule,
  anUpdateChainRule,
  mockUpdateChainRuleBuilderOperationMutation,
} from '__generated__';
import {
  CHAIN_RULE_DATA,
  ruleBuilderQuery_chain_updated,
} from 'mocks/queries/RuleBuilderQueryOperation.mocks';
import { delay, HttpResponse } from 'msw';

export const updateChainRuleResponse = {
  __typename: 'Mutation' as const,
  updateChainRule: anUpdateChainRule({
    data: {
      ...aChainRule({
        ...ruleBuilderQuery_chain_updated.rule,
      }),
      // @ts-ignore windowSizeInMilliseconds is aliased which causes issues with typing since MSW doesn't handle this case
      windowSizeMilliseconds: CHAIN_RULE_DATA.windowSizeMilliseconds,
    },
  }),
};

export const handlers = [
  mockUpdateChainRuleBuilderOperationMutation(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        // @ts-ignore windowSizeInMilliseconds is aliased which causes issues with typing since MSW doesn't handle this case
        data: updateChainRuleResponse,
      });
    }
  ),
];
